// third-party
// types
import axiosDomain from "../../utils/axios/axiosDomain";
import { dispatch } from "../index";
import member from "store/slices/member";
import guardian from "store/slices/guardian";
import { User } from "../../types/type/users-types";
import { changeLoadingOperationStatus, changeLoadingStatus } from 'store/slices/loading';
import { AffiliationBodyType } from "../../types/type/financials-types";

// ----------------------------------------------------------------------

export function getAllMembers() {
    return async () => {
        try {
            dispatch(changeLoadingStatus(true))
            const response = await axiosDomain.get('/affiliates');
            if (response.data.status == 'OK') {
                dispatch(member.actions.getAllMembers(response.data.result));
            } else {
                dispatch(member.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingStatus(false))
        } catch (error) {
            dispatch(member.actions.hasError(error));
            dispatch(changeLoadingStatus(false))
        }
    };
}

export function addMember(memberBody: User) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.post('/affiliates/add', memberBody);
            if (response.data.status == 'OK') {
                dispatch(member.actions.insertNewMember(response.data.result));
            } else {
                dispatch(member.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(member.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function updateMember(memberId: String | undefined, affiliationBody: AffiliationBodyType) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            // const delResponse = await axiosDomain.delete('/affiliationtest/' + memberId);
            const response = await axiosDomain.put('/affiliation/' + memberId, affiliationBody);
            if (response.data.status == 'OK') {
                dispatch(member.actions.insertNewMember(response.data.result));
                dispatch(guardian.actions.updateGuardian(response.data.result));
            } else {
                dispatch(member.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(member.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function updateMemberAffiliationTest(memberId: String | undefined, affiliationBody: AffiliationBodyType) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.put('/affiliationtest/' + memberId, affiliationBody);
            if (response.data.status == 'OK') {
                dispatch(member.actions.insertNewMember(response.data.result));
                dispatch(guardian.actions.updateGuardian(response.data.result));
            } else {
                dispatch(member.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(member.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}


export function deleteMember(memberId: String | undefined, affiliationBody: any) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.delete('/affiliation/' + memberId, affiliationBody);
            if (response.data.status == 'OK') {
                dispatch(member.actions.deleteMember(memberId));
                dispatch(guardian.actions.deleteGuardian(memberId));
            } else {
                dispatch(member.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(member.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}